import { render, staticRenderFns } from "./DeleteModalNew.vue?vue&type=template&id=c8432a0e&"
import script from "./DeleteModalNew.vue?vue&type=script&lang=js&"
export * from "./DeleteModalNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports